import { extractFromCookies } from '../helpers/utils';
import { ILinkAccountCustomer, ILoyaltyCustomer } from '../interface/customer.interfaces';
import api from './api';
import { APIProxy } from './api-proxy';
import apiWithRefreshToken from './apiWithRefreshToken';

const getBalanceRequest = async (context, device: string): Promise<ILoyaltyCustomer> => {
  const accessToken = extractFromCookies('access-token', context?.req?.headers?.cookie);
  try {
    const response = await api.get(
      `customer/v1/astrapay/get-balance?device=${encodeURIComponent(device)}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return error.response.data.responseText;
  }
};

const linkingAccountRequest = async (context): Promise<ILinkAccountCustomer> => {
  const accessToken = extractFromCookies('access-token', context?.req?.headers?.cookie);
  try {
    const response = await api.get('customer/v1/astrapay/linking-account', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response?.data;
  } catch (error) {
    console.log(error);
  }
};

const getRedirectUrlAstrapay = async (): Promise<ILinkAccountCustomer> => {
  try {
    const response = await api.get('/api/linking-account', {
      baseURL: process.env.NEXT_PUBLIC_BASEPATH_URL,
    });
    return response?.data;
  } catch (err) {
    console.log(err);
    return err;
  }
};

const getBalanceAstrapay = async (device: string): Promise<ILoyaltyCustomer | string> => {
  try {
    const response = await api.get(`/api/get-balance?device=${device}`, {
      baseURL: process.env.NEXT_PUBLIC_URL,
    });
    return response?.data;
  } catch (err) {
    console.log(err);
    return err;
  }
};

const checkLoyaltyProgram = async (req?, res?) => {
  if (req && res) {
    const apiProxy = new APIProxy(req, res);
    const response = await apiProxy.makeRequest({
      method: req.method!,
      url: `saphybris-proxy/v1/saphybris/astrapay/check-loyalty-program`,
    });
    return response?.data;
  } else {
    try {
      const response = await api.get('saphybris-proxy/v1/saphybris/astrapay/check-loyalty-program');
      return response?.data;
    } catch (err) {
      console.log(err);
      return err;
    }
  }
};

const resetWarningPhone = async () => {
  try {
    const response = await apiWithRefreshToken.get('/myaccount/api/loyalty/phone-updated', {
      baseURL: process.env.NEXT_PUBLIC_URL,
    });
    return response?.data;
  } catch (err) {
    console.log(err);
    return err;
  }
};

const resetEarnPoint = async () => {
  try {
    const response = await apiWithRefreshToken.get('/myaccount/api/loyalty/reset-earn-point', {
      baseURL: process.env.NEXT_PUBLIC_URL,
    });
    return response?.data;
  } catch (err) {
    console.log(err);
    return err;
  }
};

const getAstrapoints = async () => {
  try {
    const response = await apiWithRefreshToken.get('/myaccount/api/loyalty/astrapoints', {
      baseURL: process.env.NEXT_PUBLIC_URL,
    });
    return response?.data;
  } catch (err) {
    console.log(err);
    return {
      error: err,
    };
  }
};

export default {
  getBalanceRequest,
  getBalanceAstrapay,
  linkingAccountRequest,
  getRedirectUrlAstrapay,
  checkLoyaltyProgram,
  resetWarningPhone,
  getAstrapoints,
  resetEarnPoint,
};
